import { forwardRef } from 'react';
import filtersStyles from '../css/filters.module.scss';

const CustomDropdown = forwardRef<
  HTMLDivElement,
  {
    isOpen: boolean;
    onToggle: () => void;
    options: Array<{ value: string; label: string }>;
    value: { value: string; label: string };
    onChange: (item: { value: string; label: string }) => void;
    width: string;
    label?: string;
    labelClasses?: string;
    wrapperClasses?: string;
    headClasses?: string;
    placeholderStyle?: string;
    placeholder?: string;
    disabled?: boolean;
    error?: string;
  }
>(({ isOpen, onToggle, options, value, onChange, width, label, labelClasses, wrapperClasses, headClasses, placeholderStyle, placeholder, disabled, error }, ref) => {
  return (
    <div className={`${filtersStyles.filterWrapper} ${wrapperClasses}`} ref={ref} style={{ width: width }}>
      <div
        className={`${filtersStyles.filterHead} ${headClasses}`}
        style={{ opacity: disabled ? 0.7 : 1, cursor: disabled ? 'not-allowed' : 'pointer', borderColor: error ? '#ef4444' : '' }}
        onClick={() => {
          if (!disabled) {
            onToggle();
          }
        }}
        title={value?.label || placeholder || ''}
      >
        {value?.label ? (
          <p>
            <span>{label ? `${label}:` : ''}</span> <span className={`${filtersStyles.label} ${labelClasses}`}>{value.label.substring(0, 12)}</span>
          </p>
        ) : (
          <p>
            <span className={`${filtersStyles.label} ${placeholderStyle}`}>{placeholder}</span>
          </p>
        )}
        <img src="/assets/images/chevron-down.svg" alt="chevron" className={`${filtersStyles.chevronIcon} ${isOpen ? filtersStyles.active : ''}`} />
      </div>
      {isOpen && (
        <div className={filtersStyles.filterBody}>
          {options.map((item) => (
            <div
              key={item.value}
              className={`${filtersStyles.filterItem} ${value?.value === item.value ? filtersStyles.active : ''}`}
              onClick={() => {
                onChange(item);
                onToggle();
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
});

CustomDropdown.displayName = 'CustomDropdown';

export default CustomDropdown;
